<!--eslint-disable-->
<template>
    <el-container>
        <el-main class="main">
            <span class="main-element header">Selecione o ticker: </span>
            <el-select class="main-element" v-model="selectedTicker" @change="selectedTickerData = slidesText[selectedTicker]">
                <el-option v-for="item in Object.keys(slidesText)"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
            </el-select>
            <el-button class="main-element" type="primary" @click="downloadMultipager()"><el-icon name="download"></el-icon> Download Multipager</el-button>
            <el-button class="main-element" type="primary" @click="adicionarMultipager()" style="float: right"><el-icon name="plus"></el-icon> Adicionar Ticker</el-button>
            <el-input class="main-element" v-model="newTicker" placeholder="Adicione novo ticker aqui" style="float: right; width: 200px;"></el-input>
            <div class="main-element">
                <el-form :model="selectedTickerData">
                    <el-form-item label="Tese">
                        <el-input type="textarea" v-model="selectedTickerData.tese"></el-input>
                    </el-form-item>
                    <el-form-item label="Valuation">
                        <el-input type="textarea" v-model="selectedTickerData.valuation"></el-input>
                    </el-form-item>
                    <el-form-item label="Momento atual">
                        <el-input type="textarea" v-model="selectedTickerData.momentoAtual"></el-input>
                    </el-form-item>
                </el-form>
                <div style="margin-top: 10px; color: grey;">
                    <span>* Variáveis que podem ser usadas: #TARGET_PRICE, #CURRENT_PRICE, #UPSIDE</span>
                </div>
                <el-button type="primary" @click="salvarEdicaoMultipager" style="margin-top: 10px; float: left;">Salvar edição</el-button>
                <el-button type="danger" @click="deletarTicker" style="margin-top: 10px; float: left;">Apagar ticker</el-button>
                <div v-show="showAlertaSalvo" style="margin: 20px 0 0 10px; float: left;"><span style="color: green;">Salvo com sucesso!</span></div>
                <div v-show="showAlertaDeleted" style="margin: 20px 0 0 10px; float: left;"><span style="color: green;">Apagado com sucesso!</span></div>
            </div>
        </el-main>
    </el-container>
</template>

<script>
/* eslint-disable */
import firebase from 'firebase/app'
import fb from '@/services/firebaseConfig'
import pptxgen from 'pptxgenjs'

const db = fb.db

function maybeRemoveFirstZero(cnpj) {
    if (cnpj.charAt(0) == '0') {
        return cnpj.substr(1)
    }
    return cnpj
}

export default {
    data() {
        return {
            slidesText: '',
            selectedTicker: '',
            selectedTickerData: {
                tese: '',
                valuation: '',
                momentoAtual: ''
            },
            showAlertaSalvo: false,
            showAlertaDeleted: false,
            newTicker: '',
            valuesFromEconomatica: {}
        }
    },
    methods: {
        substituirVariaveisPorValor(str, ticker) {
            if (this.valuesFromEconomatica[ticker.toUpperCase()] == undefined) {
                return str
            }

            let dadosDoTickerNaEconomatica = this.valuesFromEconomatica[ticker.toUpperCase()]
            str = str.replace('#TARGET_PRICE', dadosDoTickerNaEconomatica.targetPrice.toFixed(2))
            str = str.replace('#CURRENT_PRICE', dadosDoTickerNaEconomatica.currentPrice.toFixed(2))
            str = str.replace('#UPSIDE', (dadosDoTickerNaEconomatica.targetPrice / dadosDoTickerNaEconomatica.currentPrice * 100 - 100).toFixed(2))
            return str
        },
        downloadMultipager() {       
            let pptx = new pptxgen()

            pptx.layout = 'LAYOUT_4x3'

            pptx.defineSlideMaster({
                title: "MASTER_SLIDE",
                background: { color: "FFFFFF" },
                objects: [
                    { image: { x: 0, y: 0, w: 10, h: 7.5, path: "slide-background.jpg" } },
                ],
                slideNumber: { x: 9.15, y: "93%", color: "white" },
            })

            let ticker = this.selectedTicker 

            if (this.valuesFromEconomatica[ticker.toUpperCase()] == undefined) {
                window.alert('Ticker não encontrado nos dados do Economática.')
            }

            let slide = pptx.addSlide({ masterName: "MASTER_SLIDE" })
            slide.addImage({ x: 0.5, y: 0.3, w: 2.5, h: 1, path: `companies-logos/logo_${ticker.toLowerCase()}.png` })
            slide.addImage({ x: 0.7, y: 1.6, w: 1, h: 4.7, path: `slide-arco.png` })

            slide.addImage({ x: 0.7, y: 2, w: 8.6, h: 1.1, path: `slide-seta.png` })
            slide.addText("Tese", {x: 0.85, y: 2.55, fontFace: 'Gill Sans MT', fontSize: '16'})
            slide.addText(this.substituirVariaveisPorValor(this.slidesText[ticker].tese, ticker), {x: 1.85, y: 2.55, w: 7, fontFace: 'Gill Sans MT', fontSize: '12', color: 'white'})

            slide.addImage({ x: 1, y: 3.4, w: 8.3, h: 1.1, path: `slide-seta.png` })
            slide.addText("Valuation", {x: 0.98, y: 3.95, font: 'Gill Sans MT', fontSize: '15'})
            slide.addText(this.substituirVariaveisPorValor(this.slidesText[ticker].valuation, ticker), {x: 2.15, y: 3.95, w: 7, fontFace: 'Gill Sans MT', fontSize: '12', color: 'white'})

            slide.addImage({ x: 0.7, y: 4.8, w: 8.6, h: 1.1, path: `slide-seta.png` })
            slide.addText("Momento\nAtual", {x: 0.68, y: 5.35, font: 'Gill Sans MT', fontSize: '15'})
            slide.addText(this.substituirVariaveisPorValor(this.slidesText[ticker].momentoAtual, ticker), {x: 1.85, y: 5.35, w: 7, fontFace: 'Gill Sans MT', fontSize: '12', color: 'white'})

            pptx.writeFile(ticker)
        },
        changeShowEditarMultipager() {
            this.showEditarMultipager = !this.showEditarMultipager
        },
        async salvarEdicaoMultipager() {
            let obj = {}
            obj[this.selectedTicker] = this.selectedTickerData
            await db.collection('multipagers').doc('firstSlideText').update(obj)
            let firstSlideText = await db.collection('multipagers').doc('firstSlideText').get()
            this.slidesText = firstSlideText.data()
            this.showAlertaSalvo = true
            setTimeout(function(){ this.showAlertaSalvo = false }.bind(this), 3000)
        },
        async adicionarMultipager() {
            let obj = {}
            obj[this.newTicker] = {
                tese: '',
                valuation: '',
                momentoAtual: ''
            }
            this.newTicker = ''
            await db.collection('multipagers').doc('firstSlideText').update(obj)
            let firstSlideText = await db.collection('multipagers').doc('firstSlideText').get()
            this.slidesText = firstSlideText.data()
        },
        async deletarTicker() {
            delete this.slidesText[this.selectedTicker]
            await db.collection('multipagers').doc('firstSlideText').set(this.slidesText)
            this.showAlertaDeleted = true
            setTimeout(function(){ this.showAlertaDeleted = false }.bind(this), 3000)
        }
    },
    computed: {},
    async created() {
        this.slidesText = (await db.collection('multipagers').doc('firstSlideText').get()).data()
        this.valuesFromEconomatica = (await db.collection('dadosEconomatica').doc('multipagers').get()).data()
        console.log(this.valuesFromEconomatica)
    },
}
</script>

<style scoped>
.main {
    padding: 10px;
}
.main-element {
    margin-left: 10px;
}
.header {
    font-family: Calibri;
    color: #444547;
    font-size: 19px;
}
</style>